import React from 'react';
import { FaTimes } from 'react-icons/fa';

const QRCodePanel = ({ onClose }) => {
  return (
    <div className="qr-code-container">
      <button className="close-qr" onClick={onClose}>
        <FaTimes />
      </button>
      <div className="qr-code">
        {/* Simple QR code representation */}
        <div style={{ 
          width: '100%', 
          height: '100%', 
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 1fr)',
          gridTemplateRows: 'repeat(5, 1fr)',
          gap: '2px'
        }}>
          {Array.from({ length: 25 }).map((_, i) => (
            <div 
              key={i} 
              style={{
                backgroundColor: Math.random() > 0.7 ? 'black' : 'transparent',
                width: '100%',
                height: '100%'
              }}
            />
          ))}
        </div>
      </div>
      <div className="download-text">Download iOS App</div>
      <div className="app-info">Unleash the Power of Earth Insights</div>
    </div>
  );
};

export default QRCodePanel; 